module.exports = __webpack_public_path__ + "img/electric_no_zone_selected.0c9df830.svg";